import React from 'react';
import WorkoutList from './WorkoutList';
import SwimmingStylesChart from './SwimmingStylesChart';
import TrainingZonesChart from './TrainingZonesChart';
import styles from './DashboardPage.module.css';
import PerformancePage from '../PerformancePage/PerformancePage';
import TrainingZonesPage from '../TestsPage/TrainingZonesPage';

export default function DashboardPage() {
    return (
        <div className={styles.dashboardFlex}>
            <div className={styles.dashboardRow}>
                <div className={styles.dashboardItem + ' island'}>
                    <WorkoutList />
                </div>

                <div className={styles.dashboardColumn}>
                    <div className={styles.dashboardItem + ' island'}>
                        <SwimmingStylesChart />
                    </div>
                    <div className={styles.dashboardItem + ' island'}>
                        <TrainingZonesChart />
                    </div>
                </div>
            </div>
            <div style={{ width: '100%' }}>
                <PerformancePage
                    showTable={false}
                    showPerformanceChart={true}
                    showReadinessChart={true}
                />
            </div>
            <div className={styles.dashboardItem} style={{ padding: '0' }}>
                <h1 className={'island'} style={{ padding: '5px', textAlign: 'center' }}>
                    Training Zones
                </h1>
                <TrainingZonesPage />
            </div>
        </div>
    );
}
